/* eslint-disable @typescript-eslint/no-explicit-any */
import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, } from '@chakra-ui/react';
import React, { createContext, useState, useContext } from 'react';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const DrawerProvider = (props) => {
    const { children } = props;
    const [state, setState] = useState({});
    return (React.createElement(Provider, { value: { state, setState } },
        React.createElement(Drawer, Object.assign({ autoFocus: false, closeOnOverlayClick: !state.disableCloseOnOverlayClick, isOpen: state.show || false, placement: "right", size: state.size || 'md', onClose: () => { setState(Object.assign(Object.assign({}, state), { show: false })); state.onClose && state.onClose(); } }, state.drawerProps),
            React.createElement(DrawerOverlay, Object.assign({}, state.drawerOverlayProps),
                React.createElement(DrawerContent, Object.assign({ borderBottomLeftRadius: 16, borderTopLeftRadius: 16 }, state.drawerContentProps),
                    React.createElement(DrawerCloseButton, Object.assign({}, state.drawerCloseButtonProps)),
                    React.createElement(DrawerHeader, Object.assign({}, state.drawerHeaderProps), state.header || React.createElement(React.Fragment, null)),
                    React.createElement(DrawerBody, Object.assign({}, state.drawerBodyProps), state.body || React.createElement(React.Fragment, null)),
                    React.createElement(DrawerFooter, Object.assign({}, state.drawerFooterProps), state.footer || React.createElement(React.Fragment, null))))),
        children));
};
function useDrawer() {
    const modalContext = useContext(store);
    const showDrawer = (props) => {
        modalContext.setState(Object.assign(Object.assign({}, props), { show: true }));
    };
    const hideDrawer = () => {
        modalContext.setState(Object.assign(Object.assign({}, modalContext.state), { show: false }));
    };
    return {
        showDrawer: showDrawer,
        hideDrawer: hideDrawer
    };
}
export { store as DrawerStore, DrawerProvider, useDrawer };
//# sourceMappingURL=index.js.map